import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import mapboxgl from 'mapbox-gl'; 
mapboxgl.accessToken = 'pk.eyJ1IjoiaWFtYm9ubmUiLCJhIjoiY2x6MXZycjh0MDRoNjJrb2c5ZzVkOXZweCJ9.YvjY8yFRvS1GPF9MXhCgmg';

if ( !navigator.geolocation ) {
    alert('Tu navegador no soporta el GeoLocation');
    throw new Error('Tu navegador no soporta el GeoLocation');
}



createApp(App)
    .use(store)
    .use(router)
    .mount('#app')
